var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.704102,
    y: 22.2501,
    width: 18.0712,
    height: 18.0602,
    fill: "#D3C9F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0327,
    y: 0.910278,
    width: 18.0712,
    height: 18.0602,
    fill: "#FF8989"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.704102,
    y: 0.910278,
    width: 18.0712,
    height: 18.0602,
    fill: "#FFF1CE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0327,
    y: 22.2501,
    width: 18.0712,
    height: 18.0602,
    fill: "#0947E9",
    fillOpacity: 0.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.3ecab77ac379cdfaa5bd3149338db31e.svg";
export { ForwardRef as ReactComponent };